module.exports = __webpack_public_path__ + "img/グループ 262.4c04ef8e.png";